import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Início", -1)
const _hoisted_5 = { class: "ui-flex-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Candidatos", -1)
const _hoisted_7 = { class: "ui-flex-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Setores", -1)
const _hoisted_9 = { class: "ui-flex-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Grau de Instruções", -1)
const _hoisted_11 = { class: "ui-flex-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Configurações", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","left":"26%","bottom":"10px"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://unimarca.com.br/",
    style: {"color":"#000","font-size":"10px"},
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Desenvolvimento:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("img", {
      style: {"max-width":"90px","margin-top":"-15px"},
      itemprop: "image",
      class: "ui-logo",
      src: "/static/img/logo-unimarca.png",
      alt: "Agência Unimarca"
    })
  ])
], -1)
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-14 ant-col-xl-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-1 ant-col-xl-18 ui-d-none-mob" }, null, -1)
const _hoisted_17 = { class: "ant-col ant-col-xs-10 ant-col-xl-5" }
const _hoisted_18 = { class: "ui-dados-usuario" }
const _hoisted_19 = { class: "ui-dados-usuario-identificacao" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (!_ctx.storeApp.state.carregando)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              class: "ui-sider",
              theme: "light",
              breakpoint: "lg",
              "collapsed-width": "0",
              collapsed: _ctx.collapsed,
              "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collapsed) = $event)),
              trigger: null,
              collapsible: ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("img", {
                    itemprop: "image",
                    class: "ui-logo",
                    src: _ctx.storeApp.state.parceiroAutenticado.logo,
                    alt: "Logo"
                  }, null, 8, _hoisted_3)
                ]),
                _createVNode(_component_a_menu, {
                  selectedKeys: _ctx.selectedKeys,
                  "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                  mode: "inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, { key: "1" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "ui-flex-center",
                          to: { name: 'Usuarios' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ui-menu",
                              nome: "home"
                            }),
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, { key: "2" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: { name: 'Candidatos' } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _createVNode(_component_icone, {
                                class: "ui-menu",
                                nome: "clientes"
                              }),
                              _hoisted_6
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, { key: "3" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: { name: 'Setores' } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_icone, {
                                class: "ui-menu",
                                nome: "produtos"
                              }),
                              _hoisted_8
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, { key: "4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, { to: { name: 'GrauInstrucoes' } }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_icone, {
                                class: "ui-menu",
                                nome: "editar"
                              }),
                              _hoisted_10
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_sub_menu, { key: "5" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_component_icone, {
                            class: "ui-menu",
                            nome: "configuracoes"
                          }),
                          _hoisted_12
                        ])
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_menu_item, {
                          class: "ui-menu-item",
                          key: "6"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: { name: 'Configuracoes' } }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Gerais ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, {
                          class: "ui-menu-item",
                          key: "7"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: { name: 'MeuNegocio' } }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Meu Negócio ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, {
                          class: "ui-menu-item",
                          key: "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: { name: 'ConfiguracoesEmails' } }, {
                              default: _withCtx(() => [
                                _createTextVNode(" E-mails ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_menu_item, {
                          class: "ui-menu-item",
                          key: "9"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: { name: 'Usuarios' } }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Usuários ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["selectedKeys"]),
                _hoisted_13
              ]),
              _: 1
            }, 8, ["collapsed"]),
            _createVNode(_component_a_layout, {
              class: _normalizeClass(_ctx.collapsed?'':'ui-content')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_header, { class: "ui-layout-navbar" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.collapsed?'ui-menu-expand':'ui-menu-expand ui-f-right-mob')
                        }, [
                          (_ctx.collapsed)
                            ? (_openBlock(), _createBlock(_component_icone, {
                                key: 0,
                                nome: "menu-max",
                                onClick: _cache[2] || (_cache[2] = () => (_ctx.collapsed = !_ctx.collapsed))
                              }))
                            : (_openBlock(), _createBlock(_component_icone, {
                                key: 1,
                                nome: "menu-min",
                                onClick: _cache[3] || (_cache[3] = () => (_ctx.collapsed = !_ctx.collapsed))
                              }))
                        ], 2)
                      ]),
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                          overlay: _withCtx(() => [
                            _createVNode(_component_a_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, { key: "15" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'UsuarioMeusDados' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Meus dados ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  key: "16",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deslogar()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sair")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ant-dropdown-link",
                              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                _createVNode(_component_a_avatar, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.storeApp.getters.primeiraLetraUsuarioAutenticado()), 1)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(),
                                _createElementVNode("span", _hoisted_19, [
                                  _createTextVNode(_toDisplayString(_ctx.storeApp.getters.nomeUsuarioAutenticado()) + " ", 1),
                                  _createVNode(_component_icone, { nome: "seta-baixo" })
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_layout_content, { class: "ui-layout-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        _createVNode(_Transition, {
                          name: "fade",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}